import { Dialog } from "@rio-cloud/rio-uikit";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { userType } from "..";
import { fetchDeletedSchedule } from "../../../api/fetchScheduling";

interface IDeleteAppointmentDialogProps {
    scheduleId?: string;
    showDialog: boolean;
    handleClose: () => void;
    userType: userType;
}

type DialogContent = "confirm" | "success";

const DeleteAppointmentDialog = (props: IDeleteAppointmentDialogProps) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const [dialogContent, setDialogContent] = useState<DialogContent>("confirm");
    const [loading, setLoading] = useState(false);

    const deleteAppointment = async () => {
        setLoading(true);
        try {
            await fetchDeletedSchedule(props.scheduleId!);
            setDialogContent("success");
        } catch (err) {
            console.error("Erro ao cancelar o agendamento:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            show={props.showDialog}
            onClose={props.handleClose}
            showCloseButton
            bsSize={Dialog.SIZE_SM}
        >
            {dialogContent === "confirm" && (
                <>
                    <Dialog.Title title={intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.cancelScheduling" })} />
                    <Dialog.Body>
                        <div className="cancel-content flex flex-col">
                            <span className="text-color-darker text-size-16 text-normal">
                                {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.confirmQuestion" })}
                            </span>
                            <span className="text-color-darker text-bold text-size-18 padding-top-10">
                                {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.attention" })}
                            </span>
                            <span
                                style={{ color: "#E36E19" }}
                                className="text-size-16 padding-top-5"
                            >
                                {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.cannotUndoAfterCancel" })}
                            </span>
                        </div>
                    </Dialog.Body>
                    <Dialog.Footer>
                        <div className="flex items-center justify-between">
                            {!loading ? <p
                                className="text-bold text-size-16 cursor-pointer text-color-primary"
                                onClick={props.handleClose}
                            >
                                {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.back" })}
                            </p> : <p></p>}
                            <div className="flex gap-6">
                                <button
                                    type="button"
                                    className={`btn btn-default ${loading ? 'btn-loading' : ''}`}
                                    onClick={() => deleteAppointment()}
                                    disabled={loading}
                                >
                                    {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.cancelScheduling" })}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => navigate(`/${props.userType}/appointments/appointment?scheduling-id=${props.scheduleId}`)}
                                    disabled={loading}
                                >
                                    {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.reschedule" })}
                                </button>
                            </div>
                        </div>
                    </Dialog.Footer>
                </>
            )}

            {dialogContent === "success" && (
                <>
                    <Dialog.Title title={intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.cancelledTitle" })} />
                    <Dialog.Body>
                        <div className="cancel-content flex flex-col">
                            <span className="text-size-14 text-normal info-cancel">
                                {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.cancelSuccess" })}
                            </span>
                            <span className="text-color-darker text-bold text-size-18 padding-top-10">
                                {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.attention" })}
                            </span>
                            <span
                                style={{ color: "#B42318" }}
                                className="text-size-16 padding-top-5"
                            >
                                {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.cannotBeUndone" })}
                            </span>
                        </div>
                    </Dialog.Body>
                    <Dialog.Footer>
                        <p
                            onClick={() => {
                                props.handleClose();
                                window.location.reload();
                            }}
                            className="text-bold text-size-16 cursor-pointer text-color-primary"
                        >
                            {intl.formatMessage({ id: "intl-msg:appointmentCard.deleteAppointmentDialog.close" })}
                        </p>
                    </Dialog.Footer>
                </>
            )}
        </Dialog>
    );
}

export default DeleteAppointmentDialog;